import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexReliquidationProcessesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/reliquidation_processes`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const showReliquidationProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/reliquidation_processes/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const createReliquidationProcessRequest = ({
  dispatch,
  params,
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('post', `/reliquidation_processes`, {
    dispatch,
    params,
    formData: true,
    successCallback,
    callback,
    service
  });

export const deleteReliquidationProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('delete', `/reliquidation_processes/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const reliquidationProcessSummaryRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/reliquidation_processes/${id}/summary`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const reliquidationProcessReloadRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('put', `/reliquidation_processes/${id}/reload`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const reliquidationProcessSummaryExportRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/reliquidation_processes/export`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const closeReliquidationProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('put', `/reliquidation_processes/${id}/close`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const exportReliquidationProcessRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/reliquidation_processes/export`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const massiveDestroyReliquidationProcessRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('delete', `/reliquidation_processes/massive_destroy`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const debounceReliquidationProcessSummaryRequest = AwesomeDebouncePromise(
  reliquidationProcessSummaryRequest,
  300
);
export const debounceIndexReliquidationProcessesRequest = AwesomeDebouncePromise(
  indexReliquidationProcessesRequest,
  500
);
